export const STATUS = {
  pending: 'Pendiente',
  contacted: 'Respondió por WhatsApp',
  registered: 'Registró su iglesia',
  onboarded: 'Esquemas completados',
};

export const EMAIL_STATUS = {
  none: ['Sin enviar', 'bg-zinc-500/15 text-zinc-300 border-zinc-500/30'],
  queued: ['En cola', 'bg-amber-500/15 text-amber-300 border-amber-500/30'],
  sent: ['Enviado', 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30'],
  failed: ['Error', 'bg-red-500/15 text-red-300 border-red-500/30'],
};

export const WA_STATUS = {
  none: ['Sin enviar', 'bg-zinc-500/15 text-zinc-300 border-zinc-500/30'],
  sending: ['En cola', 'bg-amber-500/15 text-amber-300 border-amber-500/30'],
  sent: ['Enviado', 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30'],
  delivered: ['Entregado', 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30'],
  read: ['Leído', 'bg-sky-500/15 text-sky-300 border-sky-500/30'],
  failed: ['Error', 'bg-red-500/15 text-red-300 border-red-500/30'],
  undelivered: ['No entregado', 'bg-red-500/15 text-red-300 border-red-500/30'],
};

export const VARS = ['pastor', 'iglesia', 'evento', 'link_registro', 'whatsapp_soporte', 'link_whatsapp', 'guia'];

export const FUNNEL = [
  ['total', 'Congregaciones'],
  ['email_sent', 'Correos enviados'],
  ['wa_sent', 'WhatsApp enviados'],
  ['contacted', 'Respondieron'],
  ['registered', 'Registraron su iglesia'],
  ['onboarded', 'Esquemas completados'],
];
